import { useConfigContext } from "@/app";
import { Icon } from "@/components/Icon";
import { Image } from "antd-mobile";
import { useMemo } from "react";
import styles from "./index.module.scss";
const avatars_1: string[] = ["/images/avatar/avatar0.png", "/images/avatar/avatar1.png", "/images/avatar/avatar2.png", "/images/avatar/avatar3.png", "/images/avatar/avatar4.png", "/images/avatar/avatar5.png", "/images/avatar/avatar6.png", "/images/avatar/avatar7.png", "/images/avatar/avatar8.png", "/images/avatar/avatar9.png", "/images/avatar/avatar10.png", "/images/avatar/avatar11.png"];
const avatars_2: string[] = ["/images/avatar/animal/1.png", "/images/avatar/animal/2.png", "/images/avatar/animal/3.png", "/images/avatar/animal/4.png", "/images/avatar/animal/5.png", "/images/avatar/animal/6.png", "/images/avatar/animal/7.png", "/images/avatar/animal/8.png", "/images/avatar/animal/9.png", "/images/avatar/animal/10.png", "/images/avatar/animal/11.png", "/images/avatar/animal/12.png"];
const avatars_3: string[] = ["/images/avatar/lz/1.png", "/images/avatar/lz/2.png", "/images/avatar/lz/3.png", "/images/avatar/lz/4.png", "/images/avatar/lz/5.png", "/images/avatar/lz/6.png", "/images/avatar/lz/7.png", "/images/avatar/lz/8.png", "/images/avatar/lz/9.png", "/images/avatar/none.png", "/images/avatar/none.png", "/images/avatar/none.png"];
const avatars_4: string[] = ["/images/avatar/car/1.png", "/images/avatar/car/2.png", "/images/avatar/car/3.png", "/images/avatar/car/4.png", "/images/avatar/car/5.png", "/images/avatar/car/6.png"];
const avatars_5: string[] = ["/images/avatar/star/1.png", "/images/avatar/star/2.png", "/images/avatar/star/3.png", "/images/avatar/star/4.png", "/images/avatar/star/5.png", "/images/avatar/star/6.png", "/images/avatar/star/7.png", "/images/avatar/star/8.png", "/images/avatar/star/9.png", "/images/avatar/star/10.png", "/images/avatar/star/11.png", "/images/avatar/star/12.png"];
const avatars_6: string[] = ["/images/avatar/landscape/1.png", "/images/avatar/landscape/2.png", "/images/avatar/landscape/3.png", "/images/avatar/landscape/4.png", "/images/avatar/landscape/5.png", "/images/avatar/landscape/6.png", "/images/avatar/landscape/7.png", "/images/avatar/landscape/8.png", "/images/avatar/landscape/9.png", "/images/avatar/landscape/10.png", "/images/avatar/landscape/11.png", "/images/avatar/landscape/12.png"];
type AvatarSelectProps = {
  value?: string;
  onChange?: (value: string) => void;
};
export const AvatarSelect = (props: AvatarSelectProps) => {
  const {
    getSourcePath
  } = useConfigContext();
  const selected = useMemo(() => {
    return getSourcePath(props.value);
  }, [props.value]);
  const imgList: string[][] = [avatars_1, avatars_2, avatars_3, avatars_4, avatars_5, avatars_6];
  return <div data-sentry-component="AvatarSelect" data-sentry-source-file="index.tsx">
      <div className={styles.user_avatar}>
        <Image src={selected} width={128} height={128} fit="cover" style={{
        borderRadius: 128
      }} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      </div>
      {imgList.map((list, i) => {
      return <div key={i} className={styles.avatar_row}>
          {list.map((avatar, y) => {
          return <div key={avatar + y} className={styles.avatar} onClick={() => typeof props.onChange === "function" && avatar.indexOf('none.png') === -1 && props.onChange(avatar)}>
                <Image src={getSourcePath(avatar)} width={48} height={48} fit="cover" style={{
              borderRadius: 48
            }} />
                {selected.indexOf(avatar) !== -1 ? <div className={styles.avatar_edit}>
                    <Icon name="checked" size="16px" />
                  </div> : null}
              </div>;
        })}
        </div>;
    })}
      {/* <div className={styles.avatar_row}>
        {avatars_1.map((avatar) => {
          return (
            <div
              key={avatar}
              className={styles.avatar}
              onClick={() =>
                typeof props.onChange === "function" && props.onChange(avatar)
              }
            >
              <Image
                src={getSourcePath(avatar)}
                width={48}
                height={48}
                fit="cover"
                style={{ borderRadius: 48 }}
              />
              {selected === avatar ? (
                <div className={styles.avatar_edit}>
                  <Icon name="checked" size="16px" />
                </div>
              ) : null}
            </div>
          );
        })}
       </div> */}
    </div>;
};